import React, {useState, useRef, useEffect} from 'react';
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import {toast} from "react-toastify";
import {INVOICE_PAGES} from "../pages/JobOrderInvoicePage";
import ArchiveInvoiceModal from "../modals/ArchiveInvoiceModel";
import MarkInvoiceAsPaidModal from "../modals/MarkInvoiceAsPaidModal";
import markInvoiceAsPaidModal from "../modals/MarkInvoiceAsPaidModal";
import axios from "axios";
import Button from "../components/Button";
import PdfDownloadButton from "../components/PdfDownloadButton";

const JobOrderInvoiceDataTable = (props) => {
    const {
        jobId,
        orderId,
        parentId,
        onChangePage    = (CREATE, invoice) => {}
    } = props;

    const dataTableRef = useRef(null);

    const [order, setOrder]                                 = useState(null);
    const [markInvoiceAsPaidModal, setMarkInvoiceAsPaidModal]   = useState(null);
    const [archiveInvoiceModal, setArchiveInvoiceModal]         = useState(null);

    useEffect(() => {
        if (!!jobId && !!orderId) {
            load();
        }
    }, [jobId, orderId]);

    const load = () => {
        axios.get(route('web-api.job.order.invoice.config', {job: jobId, order: orderId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.order) {
                        setOrder(response.data.order);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const renderRowButton = (invoice) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!invoice.can && (invoice.can.view === true || can('create', 'invoice') || invoice.can.update === true || invoice.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {/*{!!invoice.can.view === true && (*/}
                                {/*    <a className={"dropdown-item cursor-pointer"}*/}
                                {/*       target='_blank'*/}
                                {/*       href={route('job.order.invoice.export', {*/}
                                {/*           job:        jobId,*/}
                                {/*           order:      orderId,*/}
                                {/*           invoice:    invoice.id,*/}
                                {/*           type:       'stream',*/}
                                {/*       }).toString()}*/}
                                {/*    >*/}
                                {/*        <span>View Invoice</span>*/}
                                {/*    </a>*/}
                                {/*)}*/}
                                {!!invoice.can.view === true && (
                                    <PdfDownloadButton
                                        label="Download Invoice"
                                        href={route('job.order.invoice.export', {
                                            job:        jobId,
                                            order:      orderId,
                                            invoice:    invoice.id,
                                        }).toString()}
                                    />
                                )}
                                {!!invoice.can.update === true && invoice.status !== "Paid" && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setMarkInvoiceAsPaidModal(invoice)}
                                    >
                                        <span>Mark As Paid</span>
                                    </button>
                                )}
                                {!!invoice.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(INVOICE_PAGES.EDIT, invoice)}
                                    >
                                        <span>Edit Invoice</span>
                                    </button>
                                )}
                                {!!invoice.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveInvoiceModal(invoice)}
                                    >
                                        <span>Delete Invoice</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    const renderTotalExclAmount = () => {
        if (!order || (!!order && !order.total_amount_excl_vat)) {
            return "-";
        }

        if (!!order.total_amount_remainder && parseFloat(order.total_amount_remainder) > 0) {
            return (
                <span>
                    {order.total_amount_excl_vat_display}
                    <small className={"ml-1 text-eh-mid-grey"} >
                        ({order.total_amount_remainder_display} remaining)
                    </small>
                </span>
            );
        } else {
            return (
                <span>
                    {order.total_amount_excl_vat_display}
                </span>
            );
        }
    }

    return (
        <React.Fragment>
            <Card
                title={"Invoices"}
                classes={"mh-100 border-0"}
            >
                <div className="row m-0 p-0">
                    <div className="col-12 col-md-4 m-0 p-0 pr-md-2 d-flex align-items-stretch">
                        <div className={"w-100 bg-eh-off-white border border-eh-off-grey mb-3 p-2"}>
                            <p className="mb-0 text-eh-off-black"><strong>Total Order Value</strong></p>
                            <p className="mb-0 text-eh-off-black">{!!order && !!order.total_amount_display ? order.total_amount_display : "-"}</p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 m-0 p-0 px-md-2 d-flex align-items-stretch">
                        <div className={"w-100 bg-eh-off-white border border-eh-off-grey mb-3 p-2"}>
                            <p className="mb-0 text-eh-off-black"><strong>Total Invoice Value (Excl VAT)</strong></p>
                            <p className="mb-0 text-eh-off-black">{renderTotalExclAmount()}</p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 m-0 p-0 pl-md-2 d-flex align-items-stretch">
                        <div className={"w-100 bg-eh-off-white border border-eh-off-grey mb-3 p-2"}>
                            <p className="mb-0 text-eh-off-black"><strong>Total Invoice Value (Incl VAT)</strong></p>
                            <p className="mb-0 text-eh-off-black">{!!order && !!order.total_amount_incl_vat_display ? order.total_amount_incl_vat_display : "-"}</p>
                        </div>
                    </div>
                </div>
                <div className={"d-flex justify-content-end mb-3"}>
                    <Button
                        label={"Create Invoice"}
                        icon={"far fa-plus-circle"}
                        classes={"btn-eh-lilac m-0"}
                        onClick={() => onChangePage(INVOICE_PAGES.CREATE, null)}
                    />
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.order.invoice.data-table', {job: jobId, order: orderId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="invoices" />}
                                fieldsToExclude={[
                                    'id',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    'reference',
                                    'amount_excl_vat',
                                    'amount_incl_vat',
                                    'status',
                                    'sent_at',
                                    'payment_due_at',
                                    'user_name',
                                ]}
                                fieldMap={{
                                    reference:          "Invoice Ref",
                                    amount_excl_vat:    "Value Excl VAT (£)",
                                    amount_incl_vat:    "Value Incl VAT (£)",
                                    sent_at:            "Date Sent",
                                    payment_due_at:     "Due Date",
                                    user_name:          "Created By"
                                }}
                                ref={dataTableRef}
                                defaultOrderByField="reference"
                                defaultOrderByDirection="desc"
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            if (value === "Outstanding") {
                                                return (
                                                    <span className={"text-danger font-weight-bold"}>{value}</span>
                                                );
                                            } else if (value === "Paid") {
                                                return (
                                                    <span className={"text-success font-weight-bold"}>{value}</span>
                                                );
                                            }

                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <MarkInvoiceAsPaidModal
                show={!!markInvoiceAsPaidModal}
                jobId={jobId}
                orderId={orderId}
                invoiceId={!!markInvoiceAsPaidModal ? markInvoiceAsPaidModal.id : null}
                parentId={parentId}
                onCancel={() => setMarkInvoiceAsPaidModal(null)}
                onComplete={(invoice) => {
                    setMarkInvoiceAsPaidModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Invoice marked as paid.</div>);
                }}
            />
            <ArchiveInvoiceModal
                show={!!archiveInvoiceModal}
                jobId={jobId}
                orderId={orderId}
                invoiceId={!!archiveInvoiceModal ? archiveInvoiceModal.id : null}
                parentId={parentId}
                onCancel={() => setArchiveInvoiceModal(null)}
                onComplete={(invoice) => {
                    setArchiveInvoiceModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Invoice deleted.</div>);
                }}
            />
        </React.Fragment>
    );
}

export default JobOrderInvoiceDataTable;
